export const ERROR_MESSAGES = "This field is required.";
export const unavailablePujaMsg = "We're sorry! The puja service you selected is currently unavailable. Please explore our other services.";
export const unavailablePujaMsgHeader = "Puja Currently Not Available";
export const unavailableProductaMsg = "We're sorry! The product you looking for currently unavailable. Please explore our other services.";
export const unavailableProductaMsgHeader = "Product Currently Not Available";
